/**
 * Blog index: tag filter + scoped search + show more.
 * Read time is computed server-side in Liquid (200 words/min, rounded up).
 */
(function () {
  'use strict';

  function initBlogRedesign() {
    var articlesContainer = document.querySelector('.blog-articles-container');
    if (!articlesContainer) return;

    var filterButtons = document.querySelectorAll('.blog-tag-tab');
    var articleCards = articlesContainer.querySelectorAll('.blog-article-card');
    var showMoreBtn = articlesContainer.querySelector('.blog-show-more-btn');
    var searchInput = document.querySelector('.blog-search__input');
    var emptyState = articlesContainer.querySelector('.blog-empty-state');

    if (!articleCards.length) return;

    var perPage = parseInt(articlesContainer.getAttribute('data-articles-per-page'), 10) || 6;
    var visibleLimit = perPage;
    var activeTag = null;
    var searchQuery = '';

    function normalize(str) {
      return (str || '').toLowerCase().trim();
    }

    function cardMatchesSearch(card) {
      if (!searchQuery) return true;
      var title = normalize(card.getAttribute('data-title'));
      var excerpt = normalize(card.getAttribute('data-excerpt'));
      var tags = normalize(card.getAttribute('data-tags'));
      return title.indexOf(searchQuery) !== -1 ||
        excerpt.indexOf(searchQuery) !== -1 ||
        tags.indexOf(searchQuery) !== -1;
    }

    function cardMatchesTag(card) {
      if (!activeTag) return true;
      var tags = card.getAttribute('data-tags') || '';
      return tags.split(/\s+/).indexOf(activeTag) !== -1;
    }

    function getFilteredCards() {
      var matched = [];
      articleCards.forEach(function (card) {
        if (cardMatchesTag(card) && cardMatchesSearch(card)) {
          matched.push(card);
        }
      });
      return matched;
    }

    function updateView() {
      var filtered = getFilteredCards();

      articleCards.forEach(function (card) {
        card.classList.add('is-hidden');
      });

      filtered.forEach(function (card, index) {
        if (index < visibleLimit) {
          card.classList.remove('is-hidden');
        }
      });

      if (emptyState) {
        emptyState.classList.toggle('is-visible', filtered.length === 0);
      }

      if (showMoreBtn) {
        showMoreBtn.style.display = filtered.length > visibleLimit ? 'inline-flex' : 'none';
      }
    }

    filterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var tag = button.getAttribute('data-tag');
        activeTag = (!tag || tag === 'all') ? null : tag;
        filterButtons.forEach(function (btn) {
          var isActive = btn === button;
          btn.classList.toggle('active', isActive);
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        visibleLimit = perPage;
        updateView();
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        searchQuery = normalize(searchInput.value);
        visibleLimit = perPage;
        updateView();
      });
    }

    if (showMoreBtn) {
      showMoreBtn.addEventListener('click', function () {
        visibleLimit += perPage;
        updateView();
      });
    }

    applyTagFromUrl();
    updateView();

    function applyTagFromUrl() {
      var requested = null;
      try {
        requested = new URLSearchParams(window.location.search).get('tag');
      } catch (e) {
        requested = null;
      }
      if (!requested) return;

      activeTag = requested;

      filterButtons.forEach(function (btn) {
        var isActive = btn.getAttribute('data-tag') === requested;
        btn.classList.toggle('active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      var tabs = document.querySelector('.blog-tabs');
      if (tabs) {
        requestAnimationFrame(function () {
          tabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }
  }

  function initTopicRows() {
    document.querySelectorAll('.blog-topic-row__see-all').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tag = btn.getAttribute('data-tag');
        var tabs = document.querySelector('.blog-tabs');
        if (tabs) {
          tabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        var tabBtn = document.querySelector('.blog-tag-tab[data-tag="' + tag + '"]');
        if (tabBtn) {
          setTimeout(function () {
            tabBtn.click();
          }, 400);
        }
      });
    });

    document.querySelectorAll('.blog-topic-row__track').forEach(function (track) {
      var isDragging = false;
      var startX = 0;
      var scrollLeft = 0;
      var hasDragged = false;

      track.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        isDragging = true;
        hasDragged = false;
        track.classList.add('is-dragging');
        startX = e.pageX;
        scrollLeft = track.scrollLeft;
      });

      track.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        e.preventDefault();
        var walk = e.pageX - startX;
        if (Math.abs(walk) > 4) {
          hasDragged = true;
        }
        track.scrollLeft = scrollLeft - walk;
      });

      function endDrag() {
        isDragging = false;
        track.classList.remove('is-dragging');
      }

      track.addEventListener('mouseup', endDrag);
      track.addEventListener('mouseleave', endDrag);

      track.addEventListener('click', function (e) {
        if (hasDragged) {
          e.preventDefault();
          e.stopPropagation();
          hasDragged = false;
        }
      }, true);
    });
  }

  function init() {
    initBlogRedesign();
    initTopicRows();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
